module.exports = __webpack_public_path__ + "img/vertical_6_6_9016.f72abf1a.png";